import { emptySelection } from "../../constants";
/**
 * Map selections according to given ordering
 * @param order
 * @param selections
 */
export var mapSelections = function (selections, order) { return order.map(function (type) { return selections.length && selections.find(function (s) { return s.outcomeType === type; }) || emptySelection; }); };
//# sourceMappingURL=mapSelections.js.map